import { jsx as _jsx } from "react/jsx-runtime";
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon, } from 'lucide-react';
import { Toaster as Sonner, toast } from 'sonner';
/**
 * Contenedor de notificaciones (toasts). Móntalo una vez en la raíz de la app y usa `toast()`.
 * En celular aparece arriba al centro para no tapar el botón principal.
 */
function Toaster({ position = 'top-center', ...props }) {
    return (_jsx(Sonner, { theme: "light", position: position, className: "toaster group", containerAriaLabel: "Notificaciones", icons: {
            success: _jsx(CircleCheckIcon, { className: "size-5 text-success" }),
            info: _jsx(InfoIcon, { className: "size-5 text-highlight" }),
            warning: _jsx(TriangleAlertIcon, { className: "size-5 text-warning" }),
            error: _jsx(OctagonXIcon, { className: "size-5 text-destructive" }),
            loading: _jsx(Loader2Icon, { className: "size-5 animate-spin text-primary" }),
        }, toastOptions: {
            classNames: {
                toast: 'font-sans! text-base! rounded-xl! shadow-lg! gap-3!',
                title: 'font-semibold!',
                description: 'text-muted-foreground! text-sm!',
                success: 'bg-success-soft! text-success-soft-foreground! border-success/30!',
                error: 'bg-danger-soft! text-danger-soft-foreground! border-destructive/30!',
                warning: 'bg-warning-soft! text-warning-soft-foreground! border-warning/30!',
                info: 'bg-highlight-soft! text-highlight-soft-foreground! border-highlight/30!',
            },
        }, style: {
            '--normal-bg': 'var(--popover)',
            '--normal-text': 'var(--popover-foreground)',
            '--normal-border': 'var(--border)',
            '--border-radius': 'var(--radius)',
        }, ...props }));
}
export { Toaster, toast };
//# sourceMappingURL=sonner.js.map